// Handoff between Music Pro web apps on one origin (MIDIGEN <-> drums2midi).
// Payloads (File, Uint8Array) wait in IndexedDB so a new or reloaded tab can
// still collect them; a BroadcastChannel message tells an open tab to look.
// Copies: apps/ui/src/shell/web/handoff.js and apps/drums2midi/resources/js/handoff.js (keep them identical).

const DB = 'musicpro-handoff', STORE = 'items', CHANNEL = 'musicpro-handoff';

function open() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx(mode, fn) {
  const db = await open();
  try {
    return await new Promise((resolve, reject) => {
      const t = db.transaction(STORE, mode), req = fn(t.objectStore(STORE));
      t.oncomplete = () => resolve(req?.result);
      t.onerror = () => reject(t.error);
    });
  } finally { db.close(); }
}

/** Leave `value` for another app under `key` and tell open tabs. */
export async function putHandoff(key, value) {
  await tx('readwrite', (s) => s.put({ value, at: Date.now() }, key));
  try { const c = new BroadcastChannel(CHANNEL); c.postMessage({ key }); c.close(); } catch {}
}

/** Collect and remove what was left under `key` (null if nothing, or older than an hour). */
export async function takeHandoff(key) {
  try {
    const item = await tx('readonly', (s) => s.get(key));
    if (!item) return null;
    await tx('readwrite', (s) => s.delete(key));
    return Date.now() - item.at < 3600e3 ? item.value : null;
  } catch { return null; }
}

/** Call `fn(key)` when another tab leaves something. Returns an unsubscribe. */
export function onHandoff(fn) {
  try {
    const c = new BroadcastChannel(CHANNEL);
    c.onmessage = (e) => fn(e.data?.key);
    return () => c.close();
  } catch { return () => {}; }
}
